import React from 'react';

import * as S from './Loader.styles';

const Loader = () => {
    return <S.Loader />;
};

export default Loader;
